import { TProductCategory } from "@components/types";
import { getSafeUrl, sanityIoImageLoader } from "@core/utils";
import Image from "next/image";
import Link from "next/link";
import React from "react";

type Props = {
    product: TProductCategory;
    loading?: "lazy" | "eager"
};


export const SmallCategoryCard: React.FC<Props> = ({ product, loading }) => {
    return (
        <div className="relative flex-shrink-0 group">
            <div className="text-center flex flex-col justify-end items-center gap-1.5 w-20">
                <Link href={`/category/${product.id}/${getSafeUrl(product.name)}`} prefetch={false}>
                    <div className="flex items-center justify-center h-18 w-18 rounded-full bg-business-100 ring-2 ring-transparent group-hover:ring-business-500/40 shadow-sm transition-all overflow-hidden">
                        <Image
                            loader={sanityIoImageLoader}
                            src={product.image || "https://cdn.jhattse.com/public/consumer/placeholder/category_circular.png"}
                            alt={product.name}
                            width="128"
                            height="128"
                            className="rounded-full h-18 w-18 aspect-square object-cover"
                            loading={loading}
                        />
                    </div>
                </Link>
                <Link href={`/category/${product.id}/${getSafeUrl(product.name)}`} prefetch={false}>
                    <div className="overflow-hidden line-clamp-2 md:line-clamp-none">
                        <p className="text-neutral-600 group-hover:text-business-500 font-semibold text-xs text-ellipsis text-center leading-tight transition-colors">{product.name}</p>
                    </div>
                </Link>
            </div>
        </div>
    )
}